import { ApiSuccessSchema } from "../../common/response.schema";
import {
  CredentialAssignOwnerBodySchema,
  CredentialAssignOwnerPathVarsSchema,
  CredentialAssignOwnerResponseSchema,
  CredentialBulkAssignOwnerBodySchema,
  CredentialBulkAssignOwnerResponseSchema,
  CredentialDeletePathVarsSchema,
  CredentialDeleteResponseSchema,
  CredentialGetPathVarsSchema,
  CredentialItemSchema,
  CredentialListParamsSchema,
  CredentialListResponseSchema,
  CredentialReconnectPathVarsSchema,
  CredentialReconnectResponseSchema,
  CredentialSecretPathVarsSchema,
  CredentialSecretResponseSchema,
  CredentialSecretUpdateBodySchema,
  CredentialUpdateBodySchema,
  CredentialUpdatePathVarsSchema,
  CredentialUpdateSharingBodySchema,
  CredentialUpdateSharingPathVarsSchema
} from "./schemas";

export const ZCredentials = {
  List: {
    method: "GET" as const,
    path: "/api/credentials",
    Params: CredentialListParamsSchema,
    Response: ApiSuccessSchema(CredentialListResponseSchema)
  },

  Get: {
    method: "GET" as const,
    path: "/api/credentials/:id",
    PathVars: CredentialGetPathVarsSchema,
    Response: ApiSuccessSchema(CredentialItemSchema)
  },

  Update: {
    method: "PATCH" as const,
    path: "/api/credentials/:id",
    PathVars: CredentialUpdatePathVarsSchema,
    Body: CredentialUpdateBodySchema,
    Response: ApiSuccessSchema(CredentialItemSchema)
  },

  /**
   * WHO may spend this credential.
   *
   * 🔴 ITS OWN ROUTE RATHER THAN A FIELD ON `Update`, BECAUSE THE TWO ARE GATED
   * DIFFERENTLY. `PATCH /credentials/:id` is EDITOR — renaming a credential is
   * an editorial act. Declaring it PERSONAL takes it away from everyone else in
   * the organisation and declaring it SHARED hands it to them, so it is an OWNER
   * decision, and a field on the EDITOR body would let any editor make it.
   */
  UpdateSharing: {
    method: "PATCH" as const,
    path: "/api/credentials/:id/sharing",
    PathVars: CredentialUpdateSharingPathVarsSchema,
    Body: CredentialUpdateSharingBodySchema,
    Response: ApiSuccessSchema(CredentialItemSchema)
  },

  Reconnect: {
    method: "POST" as const,
    path: "/api/credentials/:id/reconnect",
    PathVars: CredentialReconnectPathVarsSchema,
    Response: ApiSuccessSchema(CredentialReconnectResponseSchema)
  },

  GetSecret: {
    method: "GET" as const,
    path: "/api/credentials/:id/secret",
    PathVars: CredentialSecretPathVarsSchema,
    Response: ApiSuccessSchema(CredentialSecretResponseSchema)
  },

  UpdateSecret: {
    method: "PUT" as const,
    path: "/api/credentials/:id/secret",
    PathVars: CredentialSecretPathVarsSchema,
    Body: CredentialSecretUpdateBodySchema,
    Response: ApiSuccessSchema(CredentialSecretResponseSchema)
  },

  AssignOwner: {
    method: "PATCH" as const,
    path: "/api/credentials/:id/owner",
    PathVars: CredentialAssignOwnerPathVarsSchema,
    Body: CredentialAssignOwnerBodySchema,
    Response: ApiSuccessSchema(CredentialAssignOwnerResponseSchema)
  },

  BulkAssignOwner: {
    method: "PATCH" as const,
    path: "/api/credentials/bulk/owner",
    Body: CredentialBulkAssignOwnerBodySchema,
    Response: ApiSuccessSchema(CredentialBulkAssignOwnerResponseSchema)
  },

  Delete: {
    method: "DELETE" as const,
    path: "/api/credentials/:id",
    PathVars: CredentialDeletePathVarsSchema,
    Response: ApiSuccessSchema(CredentialDeleteResponseSchema)
  }
} as const;
